import { Button, Form, Modal, Select } from "antd";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import GlobalContext from "../../../context/GlobalContext";
import { useTranslation } from "react-i18next";
import { useLoader } from "../../../context/LoaderContext";
import axiosInstance from "../../../utils/axios";
import PropTypes from "prop-types";

const SelectionModal = (props) => {
  // eslint-disable-next-line react/prop-types
  const { isModalVisible, setIsModalVisible } = props;
  const { t } = useTranslation();
  const { form } = useContext(GlobalContext);
  const navigate = useNavigate();
  const { setSurveyJson, setIsLoading, setShowingPreview } = useLoader();

  const handleCancel = () => {
    setIsModalVisible([]);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((response) => {
        setIsLoading(true);
        axiosInstance
          .get(
            `${import.meta.env.VITE_APP_GEOPROD_API}/admin-bpm/contrat/${
              import.meta.env.VITE_ID_LIGNE_PRODUIT_ANNEXE
            }`,
            {
              headers: {
                Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
                  ?.Acces_Token,
              },
            }
          )
          .then((res) => {
            setIsLoading(false);

            sessionStorage.removeItem("id_affaire_annexe");
            setShowingPreview(false);

            navigate("/annexes/save?affaire_id=" + response.EPFID);
            setIsModalVisible([]);
            setSurveyJson(res?.data?.contrat?.form);
          })
          .catch(() => {
            setIsLoading(false);
          });
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
  };

  return (
    <Modal
      title={t("Sélectionnez la situation de l'Annexe")}
      open={isModalVisible?.length > 0}
      onOk={handleOk}
      footer={false}
      onCancel={handleCancel}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={t("EPF de l'Annexe")}
          name={"EPFID"}
          rules={[
            {
              required: true,
              message: t("Veuillez selectionner un EPF."),
            },
          ]}
        >
          <Select style={{ width: "100%" }}>
            {isModalVisible?.map((elem) => (
              <Select.Option key={elem.affaire_id} value={elem.affaire_id}>
                {elem?.establishment_data_commercial_name ||
                  elem?.establishment_data_official_name ||
                  elem?.legal_entity_official_name}{" "}
                - {elem?.registration_number}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
      <div style={{ textAlign: "center" }}>
        <Button
          onClick={handleOk}
          type="primary"
          style={{
            backgroundColor: "#214082",
            borderColor: "#214082",
            marginRight: "10px",
            width: "7rem",
          }}
        >
          {t("Valider")}
        </Button>

        <Button
          style={{
            backgroundColor: "#E2E9F7",
            color: "#214082",
            border: "#9BACCF 1px solid",
            marginInline: "0.5rem",
            width: "7rem",
          }}
          onClick={handleCancel}
        >
          {t("Annuler")}
        </Button>
      </div>
    </Modal>
  );
};

SelectionModal.propTypes = {
  isModalVisible: PropTypes.array,
  setIsModalVisible: PropTypes.func,
};

export default SelectionModal;
